  <template>
    <v-dialog persistent  v-model="show"    max-width="1500px">
     
        <v-card >

            <!-- <v-card-title class="headline layout justify-center red--text" >
                <h5>Buscador de Orden de Trabajo</h5>              
            </v-card-title> -->

            <v-btn
                        icon
                        color="black"
                        @click="cancelarBuscadorMat()"
                        style="position: absolute; top: 10px; right: 10px; z-index: 10;"
                    >
                        <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-row>
                <v-col cols="6" sm="6" md="6">
                    <v-radio-group v-model="flags" row dense>                       
                            <v-radio label="Por Nombre" value="2"></v-radio>
                            <v-radio label="Por N° OT" value="1"></v-radio>
                            <v-radio label="Por Detalle en OT" value="3"></v-radio> 
                            <v-radio label="Por Articulo en OT" value="5"></v-radio>                         
                    </v-radio-group>  
                </v-col>
                <v-col cols="3" sm="3" md="3">                  
                    <v-card-title>
                        <v-text-field
                            v-model="search1"
                            append-icon="mdi-magnify"
                            label="Ingrese un Nombre"
                            single-line
                            hide-details                         
                            v-if="mostrar"  
                            @input="mayus(search1)"
                            @keypress.enter="nuevoFiltro(flags,'')"  
                            dense  
                        ></v-text-field> 

                        <v-text-field
                            v-model="search2"
                            append-icon="mdi-magnify"
                            label="Ingrese un Número"
                            single-line
                            hide-details                           
                            v-if="mostrar1"                         
                            @input="mayus(search2)" 
                            @keypress.enter="nuevoFiltro(flags,'')"  
                            dense 
                            
                        ></v-text-field> 

                        <v-text-field                           
                            v-model="search3"
                            append-icon="mdi-magnify"
                            label="Ingrese un Detalle OT"
                            single-line
                            hide-details
                            :custom-filter="filterOnlyCapsText" 
                            v-if="mostrar3" 
                            @keypress.enter="nuevoFiltro(flags,'')"   
                            @input="mayus(search3)"   
                            dense  
                        ></v-text-field> 


                        <v-text-field                           
                            v-model="search5"
                            append-icon="mdi-magnify"
                            label="Ingrese un Articulo"
                            single-line
                            hide-details
                            :custom-filter="filterOnlyCapsText" 
                            v-if="mostrar5" 
                            @keypress.enter="nuevoFiltro(flags,'')"   
                            @input="mayus(search5)"   
                            dense  
                        ></v-text-field> 

                    </v-card-title>
                </v-col>
                <v-col  cols="3" sm="3" md="3">
                    <v-card-title>
                        <v-text-field
                            v-model="search4"
                            v-if="search2 != '' || search1 != '' || search3 != ''"
                            append-icon="mdi-magnify"
                            label="Ingrese una palabra"  
                            @keypress.enter = "nuevoFiltro(flags, search4)" 
                            @input="mayus(search4)"
                            dense
                        ></v-text-field>  
                    </v-card-title>                                             
                </v-col>
            </v-row>     
           
           
           
            <v-data-table 
                     v-if="mostrar"           
                    dense
                    :headers="headersMat"                     
                    class="elevation-1"                  
                    :items="dessertsMat"  
                    :items-per-page.sync="itemsPerPage"
                    :items-per-page-options="itemsPerPageOptions"
                   
            
                >

                    <template v-slot:item.actions="{ item }"   >
                        <v-icon
                            small
                            class="mr-2"
                            @click="editItem(item,1)"
                            color="red"
                        >
                            mdi-check
                        </v-icon>                    
                                            
                    </template>   

                   

            </v-data-table> 
            
                    
          
            <v-data-table
                    v-if="mostrar1"
                    dense
                    :headers="headersMat1"
                    :items="dessertsMat1"    
                    class="elevation-1"
                    :items-per-page.sync="itemsPerPage"
                    :items-per-page-options="itemsPerPageOptions"
                  
                   
                                   
                >
                    <template v-slot:item.actions="{ item }" >
                            <v-icon
                                small
                                class="mr-2"
                                @click="editItem(item,2)"
                                color="red"
                                
                                >
                                mdi-check
                                </v-icon>
                                
                    </template>              
            </v-data-table> 
            
            
           
            <v-data-table 
                    v-if="mostrar3"               
                    dense
                    :headers="headersMat2"                     
                    class="elevation-1"                   
                    :items="dessertsMat2" 
                    :items-per-page.sync="itemsPerPage"
                    :items-per-page-options="itemsPerPageOptions"
 
            >

                    <template v-slot:item.actions="{ item }"   >
                        <v-icon
                            small
                            class="mr-2"
                            @click="editItem(item,3)"
                            color="red"
                        >
                            mdi-check
                        </v-icon>                            
                    </template>  

            </v-data-table>

             
            
                                                   
            <v-data-table 
                    v-if="mostrar5"               
                    dense
                    :headers="headersMat5"                     
                    class="elevation-1"                   
                    :items="dessertsMat5" 
                    :items-per-page.sync="itemsPerPage"
                    :items-per-page-options="itemsPerPageOptions"
 
            >

                    <template v-slot:item.actions="{ item }"   >
                        <v-icon
                            small
                            class="mr-2"
                            @click="editItem(item,3)"
                            color="red"
                        >
                            mdi-check
                        </v-icon>                            
                    </template>  

            </v-data-table>

           
            
           

       
            
       
        </v-card>



        <v-dialog
            max-width="400"
            persistent
            v-model="cartel"
        >
            <v-card>
                <v-toolbar
                    color="primary"
                    dark
                    class="custom-toolbar"
                >
                    Registro en proceso
                </v-toolbar>
                <v-card-text>
                    <div class="text-h6 pa-2">Aguarde, consultando los datos..</div>
                </v-card-text>
            </v-card>
        </v-dialog>

    
    
    </v-dialog>    
    
    
   
        


</template>

<script>
 
import Axios from "../../../axios-auth-sistemas";
import moment from "moment";

export default {
    name:'BuscadorOT',
    data(){
        return{
            dialogMaterial: true,
            headersMat: 
                [
                        {text: 'Otrabajo',value: 'otrabajo',  align: "left",sortable: false, filterable: false},
                        { text: 'Seleccionar', value: 'actions', sortable: false ,  align: "right",sortable: false  },
                        {text: 'Detalle',value: 'detalle',  align: "left",sortable: false },
                        {text: 'Fecha Cierre',value: 'fec_cierre',  align: "left",sortable: false,filterable: false },
                        {text: 'Taller',value: 'taller',  align: "center",sortable: false,filterable: false },
                       
                        
                ],
            headersMat1: 
                [
                        {text: 'Otrabajo',value: 'otrabajo',  align: "left",sortable: false},
                        { text: 'Seleccionar', value: 'actions', sortable: false ,  align: "right",sortable: false  },
                        {text: 'Detalle',value: 'detalle',  align: "left",sortable: false,  filterable: false },
                        {text: 'Fecha Cierre',value: 'fec_cierre',  align: "left",sortable: false,filterable: false },
                        {text: 'Taller',value: 'taller',  align: "center",sortable: false,filterable: false },
                     
                        
                ],
            headersMat2:
                [
                        {text: 'Otrabajo/Item',value: "otrabajoit",  align: "left",sortable: false},
                        { text: 'Seleccionar', value: 'actions', sortable: false ,  align: "right",sortable: false  },
                        {text: 'Detalle',value: "detalle",  align: "left",sortable: false,  filterable: false },
                        {text: 'Fecha Cierre',value: 'fec_cierre',  align: "left",sortable: false,filterable: false },
                        {text: 'Taller',value: "taller",  align: "center",sortable: false,filterable: false },
                       
                        
                ],

                headersMat5:
                [
                        {text: 'Otrabajo/Item',value: "otrabajoit",  align: "left",sortable: false},
                        { text: 'Seleccionar', value: 'actions', sortable: false ,  align: "right",sortable: false  },
                        {text: 'Articulo',value: "articulo",  align: "left",sortable: false,  filterable: false },
                        {text: 'Detalle',value: "detalle",  align: "left",sortable: false,  filterable: false },
                        {text: 'Fecha Cierre',value: 'fec_cierre',  align: "left",sortable: false,filterable: false },
                        {text: 'Taller',value: "taller",  align: "center",sortable: false,filterable: false },
                       
                        
                ],


             
                search1:'',
                search2:'',
                search3:'',
                search4:'',
                search5:'',
                dessertsMat:[], 
                dessertsMat1:[], 
                dessertsMat2:[], 
                dessertsMat5:[],
                mostrar:true,
                mostrar1:false,
                mostrar3:false,
                mostrar4:false,
                mostrar5:false,
                flags:"",
                editedIndex:-1,
                vSel:
                {
                    otrabajo:'',
                    detalle:'',
                        
                    
                },
                datos:[],
                itemsPerPage: -1, // Configura itemsPerPage en -1 para mostrar todos los elementos por defecto
                itemsPerPageOptions: [-1,10, 25, 50,75,100,200],

                cartel:false,
            
        }
    },
    props: ["visible", "pnumot", "pnombreot", "pflag"],


    computed: {
        show: {
           
            get() {      
                
               console.log("el flag seleccionado en el show",this.flags)

               if (this.visible == true)
               {
                
                    if ( this.flags == "2") {
                        this.mostrar = true;
                        this.mostrar1 = false;
                        this.mostrar3 = false;
                        this.mostrar5 = false;
                        this.search1 = "";
                        this.search2 ="";
                        this.search4="";
                        this.mostrarDatos();
                    }
                    if ( this.flags == "1") {
                    
                        this.mostrar = false;
                        this.mostrar1 = true;
                        this.mostrar3 = false;
                        this.mostrar5 = false;
                        this.search1 = "";
                        this.search2 ="";
                        this.search4="";
                        this.mostrarDatos();
                    }
                    if (this.flags == "3" ) {
                        this.mostrar = false;
                        this.mostrar1 = false;
                        this.mostrar3 = true;  
                        this.mostrar5 = false;              
                        console.log(this.mostrar3)
                        this.search3="";
                        this.search4="";
                        this.mostrarDatos();
                    }
                    if (this.flags == "5" ) {
                        this.mostrar = false;
                        this.mostrar1 = false;
                        this.mostrar3 = false;   
                        this.mostrar5 = true;                
                        console.log(this.mostrar5)
                        this.search3="";
                        this.search4="";  
                        this.search1=""; 
                        this.search2="";                
                        this.mostrarDatos();
                    }  
                    

                }
                return this.visible;
            },
            

            set(value) {
               
                if (!value) {                   
                this.$refs.form.resetValidation();
                document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                this.$emit("close");
                }
            },
               
        },

     
    },

    mounted(){
      
        
       console.log("paso por el mounted")
        this.flags = "2"
        this.pflags = "2"
       
    },

     activated(){
      
        
       console.log("paso por el activate")
        this.flags = "2"
        this.pflags = "2"
       
    },

    methods: {

        mostrarMensaje(item) {
      // Puedes mostrar un mensaje o realizar una acción aquí
        alert(`Presionaste Enter en la fila con el ID: ${item.id}`);
        },
        cancelarBuscadorMat(){
            this.flags="2"
            this.search1=""
            this.search2=""
            this.search3=""
            this.search4=""
             this.search5=""
            this.$emit("close");
        },

        mostrarDatos(deta){

          
            let self = this; 

            console.log("DETA", deta)

            if (deta == null || deta == "" || deta == undefined)
            {

                console.log("PASO POR DETA IS NULL", deta)

                if (this.flags == "1" || this.flags == "2" )
                {

                        self.dessertsMat = [];
                        self.dessertsMat1 = [];
                        console.log("el deta es espacio en blanco")
                        Axios              
                        .get("/CtaOtPro/BuscadorOT")
                        .then(r => {       
                            
                            
                          
                            

                            r.data.forEach(element => {

                                const fechaCierre = moment(element.feccierre, "YYYY/MM/DD HH:mm:ss");

                                self.dessertsMat.push({

                                    otrabajo: element.otrabajo,
                                    detalle: element.detalle,
                                // fec_cierre :element.feccierre == null || element.feccierre =="" ? "" : moment(element.feccierre).format("DD/MM/YYYY"),
                                     fec_cierre :element.feccierre == null || element.feccierre =="" ? "" : fechaCierre.format('DD/MM/YYYY'),                           
                                    taller: element.taller



                                })

                                self.dessertsMat1.push({

                                    otrabajo: element.otrabajo,
                                    detalle: element.detalle,
                                //   fec_cierre :element.feccierre == null || element.feccierre =="" ? "" : moment(element.feccierre).format("DD/MM/YYYY"),
                                   fec_cierre :element.feccierre == null || element.feccierre =="" ? "" : fechaCierre.format('DD/MM/YYYY'),
                                    taller: element.taller



                                })




                                
                        

                            

                            })

                        

                                        
                        }).catch(r => {        
                                console.log("error en el mostrar")
                                this.$swal("","Error en el buscador de orden de trabajo", "info")
                        });
                }



                if (this.flags == "3" )
                {  

                    
                  
                    self.dessertsMat2=[];

                    Axios
                    .get("/CtaOtPro/BuscadorDeta1?", {
                        params: {
                            id: '',
                            id1 :3,
                        },
                        })   
                        .then((r) => {       
                            
                                             

                                r.data.forEach(element => {

                                    const fechaCierre = moment(element.feccierre, "YYYY/MM/DD HH:mm:ss");

                                    self.dessertsMat2.push({

                                        otrabajoit: element.otrabajoit,
                                        detalle: element.detalle,
                                        // fec_cierre :element.feccierre == null || element.feccierre =="" ? "" : moment(element.feccierre).format("DD/MM/YYYY"),
                                        fec_cierre :element.feccierre == null || element.feccierre =="" ? "" : fechaCierre.format('DD/MM/YYYY'),                           
                                        taller: element.taller,
                                        otrabajo: element.otrabajo,
                                        



                                     })
                                 })    
                                
                                
                              

                        }).catch(r => {        
                              
                                this.$swal("","No se encontro nada en la base de datos con la palabra ingresada", "info")
                            
                        });

                
                 


                }







                if (this.flags == "5" )
                {  

                    const flag= this.flags;
                  
                    self.dessertsMat5=[];

                    console.log("paso por flags5")

                    Axios
                    .get("/CtaOtPro/BuscadorDeta1?", {
                        params: {
                            id: '',
                            id1: flag,
                        },
                        })   
                        .then((r) => {       
                            
                                             

                                r.data.forEach(element => {

                                    const fechaCierre = moment(element.feccierre, "YYYY/MM/DD HH:mm:ss");

                                    self.dessertsMat5.push({

                                        otrabajoit: element.otrabajoit,
                                        detalle: element.detalle,
                                        // fec_cierre :element.feccierre == null || element.feccierre =="" ? "" : moment(element.feccierre).format("DD/MM/YYYY"),
                                        fec_cierre :element.feccierre == null || element.feccierre =="" ? "" : fechaCierre.format('DD/MM/YYYY'),                           
                                        taller: element.taller,
                                        otrabajo: element.otrabajo,
                                        



                                     })
                                 })    
                                
                                
                              

                        }).catch(r => {        
                              
                                this.$swal("","Noooo se encontro nada en la base de datos con la palabra ingresada", "info")
                            
                        });

                
                 


                }




            }            
              
            
            





           
        },

        

        mayus(e) {
                this.search1= this.search1.toUpperCase();
                this.search2= this.search2.toUpperCase();
                this.search3= this.search3.toUpperCase();
                this.search4= this.search4.toUpperCase();
                this.search5= this.search5.toUpperCase();
                if(this.search2 == null && this.flags==1){
                    this.search4="";
                }
                if(this.search1 == null && this.flags==2){
                    this.search4="";
                }
                if(this.search3 == null && this.flags==3){
                    this.search4="";
                }

                //e.value = e.value.toUpperCase();
        },

        filterOnlyCapsText (value, search, item) {
           
            return value != null &&
                search != null &&
                typeof value === 'string' &&
                value.toString().toLocaleUpperCase().indexOf(search) !== -1
        },

        editItem(item,senal){
            if (senal == 1 ) {
                console.log(item)           
                this.editedIndex = this.dessertsMat.indexOf(item)
                this.vSel = Object.assign({}, item)
                console.log(this.vSel.otrabajo)
                console.log(this.vSel.detalle)
                console.log(this.pnumot)
                this.datos.otrabajo = this.vSel.otrabajo  
                this.$store.commit('saveOTSeleccionada',this.vSel.otrabajo )   
               
                this.$emit('otSel', this.vSel.otrabajo)
               this.$emit("close");
              // this.flags="1"
               this.search1=""
                this.search2=""
                this.search3=""
                this.search4=""
            }
            else
            if (senal == 2) 
            {
                console.log(item)           
                this.editedIndex = this.dessertsMat1.indexOf(item)
                this.vSel = Object.assign({}, item)
                console.log(this.vSel.otrabajo)
                console.log(this.vSel.detalle)
                this.$store.commit('saveOTSeleccionada',this.vSel.otrabajo )  
                this.$emit('otSel', this.vSel.otrabajo)
                this.$emit("close");
                //this.$emit("close");
                //this.flags="1"
                this.search1=""
                this.search2=""
                this.search3=""
                this.search4=""
            }
            else
            if (senal == 3) 
            {
               
                console.log(item)           
                this.editedIndex = this.dessertsMat2.indexOf(item)
                this.vSel = Object.assign({}, item)
                console.log(this.vSel.otrabajo)
                console.log(this.vSel.detalle)
                this.$store.commit('saveOTSeleccionada',this.vSel.otrabajo )                   
                this.$emit('otSel',this.vSel.otrabajo)
                this.$emit("close");  
                //this.flags="1"
                this.search1=""
                this.search2=""
                this.search3=""
                this.search4=""             

            }
           
        }, 

        limpiar(){

            this.search1="";
            this.search2="";
            this.search3="";

        },


        // buscarDetalle(id)
        // {
       
        //     let self = this;            
           
        //     Axios
        //         .get("/CtaOtPro/BuscadorDeta?", {
        //         params: {
        //             id: id,
        //         },
        //         })   
        //         .then(r => {           
                    
                    
        //             console.log(r.data)
                    
        //             this.flags = "3"
        //             this.pflags = "3"
        //             console.log("mostrar" + this.mostrar3)
        //             r.data.forEach(element => {

        //                 if (element.feccierre == null && element.feccierre ==""){
        //                     const fechaCierre = moment(element.feccierre, "YYYY/MM/DD HH:mm:ss");
        //                 }
                        

        //                 self.dessertsMat2.push({

        //                     otrabajo: element.otrabajo,
        //                     detalle: element.detalle,
        //                     fec_cierre :element.feccierre == null || element.feccierre =="" ? "" :  moment(element.feccierre, "YYYY/MM/DD"),                           
        //                     taller: element.taller                       



        //                 })


                       

                      
                       

        //             })

        //             this.mostrar = false;
        //             this.mostrar1 = false;
        //             this.mostrar3 = true;
        //             this.visible=true;
        //             this.show;    
                   
        //             console.log("array")
        //             console.log(this.dessertsMat2);
        //             console.log(this.flags)
        //             console.log("fin array")


                                
        //         }).catch(r => {        
        //                 console.log("error EN EL GET detalle ot")
        //                 this.$swal("","Error en el buscador de orden de trabajo", "info")
        //         });


        // },


        nuevoFiltro(opcion, id1)
        {

           
            let self = this;    
            if(opcion == 1)
            {
               
                console.log("estoy en opcion 1")
                this.search2 = this.search2.toUpperCase(); 
                this.search4 = this.search4.toUpperCase(); 
                this.search5 ="";
                let id = this.search2;
                self.dessertsMat1 =[];

                console.log("id1", id1)

                if(id1 == null || id1 == undefined || id1 == "")
                {
                    id1= "";
                }
                
                self.cartel =true;
                Axios
                .get("/CtaOtPro/NuevoFiltroOT?", {
                params: {
                    id: id,
                    id1: id1,
                    id2: '1',
                },
                })   
                .then(r => {           
                    
                    
                  
                    r.data.forEach(element => {

                    const fechaCierre = moment(element.feccierre, "YYYY/MM/DD HH:mm:ss");

                    self.dessertsMat1.push({
                        otrabajo: element.otrabajo,
                        detalle: element.detalle,                    
                        fec_cierre :element.feccierre == null || element.feccierre =="" ? "" : fechaCierre.format('DD/MM/YYYY'),                           
                        taller: element.taller
                    })

                    self.cartel =false;
                    
                })   

                self.cartel =false;
                                
                }).catch(r => {        
                  
                        this.$swal("","Error en el buscador de orden de trabajo", "info")
                        self.cartel =false;
                });


            }



            if(opcion == 2)
            {

                console.log("estoy en opcion 2")
                this.search1 = this.search1.toUpperCase(); 
                this.search4 = this.search4.toUpperCase(); 
                let id = this.search1;
                this.search5 ="";
                self.dessertsMat=[];
                self.cartel =true;
                Axios
                .get("/CtaOtPro/NuevoFiltroOT?", {
                params: {
                    id: id,
                    id1: id1,
                    id2: '2',
                },
                })   
                .then(r => {           
                    
                    
                  
                    r.data.forEach(element => {

                    const fechaCierre = moment(element.feccierre, "YYYY/MM/DD HH:mm:ss");

                    self.dessertsMat.push({
                        otrabajo: element.otrabajo,
                        detalle: element.detalle,                    
                        fec_cierre :element.feccierre == null || element.feccierre =="" ? "" : fechaCierre.format('DD/MM/YYYY'),                           
                        taller: element.taller
                    })

                    self.cartel =false;
                    
                })   

                self.cartel =false;
                                
                }).catch(r => {        
                     
                        this.$swal("","Error en el buscador de orden de trabajo", "info");
                        self.cartel =false;
                });


            }

            if(opcion == 3)
            {

               
                console.log("estoy en opcion 3")
                this.search3 = this.search3.toUpperCase(); 
                let id = this.search3;
              
                console.log(id) 
               
                this.search4 = this.search4.toUpperCase(); 
                this.search5 ="";
              
                self.dessertsMat2=[];
                self.cartel =true;
                Axios
                .get("/CtaOtPro/NuevoFiltroOT?", {
                params: {
                    id: id,
                    id1: id1,
                    id2: '3',
                },
                })   
                .then(r => {         
                    
                    
                                        

                        r.data.forEach(element => {

                            const fechaCierre = moment(element.feccierre, "YYYY/MM/DD HH:mm:ss");

                            self.dessertsMat2.push({

                                otrabajoit: element.otrabajoit,
                                detalle: element.detalle,
                                // fec_cierre :element.feccierre == null || element.feccierre =="" ? "" : moment(element.feccierre).format("DD/MM/YYYY"),
                                fec_cierre :element.feccierre == null || element.feccierre =="" ? "" : fechaCierre.format('DD/MM/YYYY'),                           
                                taller: element.taller,
                                otrabajo: element.otrabajo,
                            })

                            self.cartel =false;


                        }) 
                        
                        console.log( "fin")
                        self.cartel =false;
                        
                }).catch(r => {        
                     
                        this.$swal("","Error en el buscador de orden de trabajo", "info");
                        self.cartel =false;
                });

            }



            if(opcion == 5)
            {

               
                console.log("estoy en opcion 5")
                this.search1 ="";
                this.search2 ="";
                this.search3 ="";
                this.search5 = this.search5.toUpperCase(); 
              
              
               
               
             
               
                self.cartel =true;
                self.dessertsMat5=[];
                
                Axios
                .get("/CtaOtPro/NuevoFiltroOT?", {
                params: {
                    id: this.search5 ,
                    id1: '1',
                    id2: '5',
                },
                })   
                .then(r => {         
                    
                    
                       console.log(r.data)     

                      // self.dessertsMat5 = r.data;               

                        r.data.forEach(element => {

                            const fechaCierre = moment(element.feccierre, "YYYY/MM/DD HH:mm:ss");

                            self.dessertsMat5.push({

                                otrabajoit: element.otrabajoit,
                                detalle: element.detalle,
                                // fec_cierre :element.feccierre == null || element.feccierre =="" ? "" : moment(element.feccierre).format("DD/MM/YYYY"),
                                fec_cierre :element.feccierre == null || element.feccierre =="" ? "" : fechaCierre.format('DD/MM/YYYY'),                           
                                taller: element.taller,
                                otrabajo: element.otrabajo,
                            })


                         }) 
                        
                        console.log( "fin")

                        self.cartel=false;
                        
                }).catch(r => {        
                     
                        this.$swal("","Error en el buscador de orden de trabajo", "info")
                        self.cartel=false;
                });

            }

        },

       

    },
}
</script> 


 



 

 
